import { t } from 'Base/modules/bk/component-property-providers/bk-translations';

const getTemplate = (text, hasBorder) => {
    const classes = hasBorder ? 'bk-button-secondary bk-button-secondary--border' : 'bk-button-secondary';
    const template = document.createElement('template');
    template.innerHTML = `
        <button data-button-secondary type="button" class="${classes}">${text || t('global.cancel')}</button>
    `;

    return template;
};

export default getTemplate;
